// 1.Create APP
import { createApp } from "vue";
import App from "./App.vue";
const app = createApp(App);

// 2.Modules
import router from "./router/index";
app.use(router);

import store from "./store/index";
app.use(store);

import LoadScript from "vue-plugin-load-script";
app.use(LoadScript);

// 4.Components
import ElementPlus from "element-plus";
import zhCn from "element-plus/es/locale/lang/zh-cn";
import "element-plus/dist/index.css";
import * as ElementPlusIconsVue from "@element-plus/icons-vue";
app.use(ElementPlus, {
    locale: zhCn,
});
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component);
}

// vant
import installVantComponents from "@/plugins/vant";
installVantComponents(app);

import FoldBlock from "@/components/common/fold-block.vue";
app.component(FoldBlock.name, FoldBlock);

import FilterWrapper from "@/components/widget/filter_wrapper.vue";
app.component(FilterWrapper.name, FilterWrapper);

import "@arco-design/web-vue/dist/arco.css";

import DeepBerryUI from "@deepberry/vue3-element-extend";
app.use(DeepBerryUI);

import svgIcon from "@/utils/svgIcon";
app.use(svgIcon);

import deviceDirective from "./directives/device/index";

app.directive("device", deviceDirective);

import { i18n } from "@/locale";
app.use(i18n);

// 5.Mount DOM
app.mount("#app");
